<template>
  <div class="d-flex justify-content-end">
    <button
      :class="[active ? 'active-button' : '', view]"
      @click="showBookmarks"
    >
      <i class="d-lg-none icon-star-empty" />
      {{ $t('common.bookmarks') }}
      <span class="d-none d-lg-inline-block"> - </span>
      <span class="d-lg-none">(</span>
      {{ bookmarksNumber }}
      <span class="d-lg-none">)</span>
      <i class="d-none d-lg-inline-block icon-star" />
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Bookmarks',
  props: {
    view: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      active: false
    }
  },
  computed: {
    ...mapGetters({
      bookmarksNumber: 'search/getBookmarksNumber',
      bookmarksList: 'search/getBookmarksList',
      isBookmarksShown: 'search/isBookmarksShown'
    })
  },
  watch: {
    isBookmarksShown(val) {
      if (!val) this.active = false
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  },
  methods: {
    ...mapActions({
      showBookmarksList: 'search/SHOW_BOOKMARKS'
    }),
    showBookmarks() {
      if (this.bookmarksNumber > 0 || this.isBookmarksShown) {
        this.active = !this.active
        this.active
          ? this.showBookmarksList(true)
          : this.showBookmarksList(false)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '~assets/css/variables.scss';

.primary-button {
  min-height: 32px;
  max-height: 32px;
}

.icon-star-empty,
.icon-star {
  color: #fcb602;
}

@media (min-width: 992px) {
  div {
    padding: 25px 30px 20px 30px;
    background-color: white;
  }
  .active-button {
    background-color: $primary;
    color: white !important;
  }

  .icon-star-empty,
  .icon-star {
    color: #ffeb3b;
  }
}
</style>
